// src/services/roleService.ts
import { StaffApiResponse, StaffCreatePayload, StaffDetailsApiResponse, StaffUpdatePayload, StaffUserApiResponse } from "types/staffTypes";
import axios from "./axiosInstance";

export const getStaff = async (params: Record<string, any>): Promise<StaffApiResponse> => {
  const response = await axios.get<StaffApiResponse>("/staff", { params });
  return response.data;
};

export const createStaff = async (payload: StaffCreatePayload): Promise<StaffUserApiResponse> => {
  const response = await axios.post<StaffUserApiResponse>("/staff", payload);
  return response.data;
};


export const updateStaff = async (staffId: string, payload: StaffUpdatePayload): Promise<StaffUserApiResponse> => {
  const response = await axios.put<StaffUserApiResponse>(`/staff/${staffId}`, payload);
  return response.data;
};

export const deleteStaff = async (staffId: string): Promise<StaffUserApiResponse> => {
  const response = await axios.delete<StaffUserApiResponse>(`/staff/${staffId}`);
  return response.data;
};


export const getStaffById = async (staffId: string): Promise<StaffDetailsApiResponse> => {
  const response = await axios.get<StaffDetailsApiResponse>(`/staff/${staffId}`);
  return response.data;
};

